var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFav(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.90002 7V17C3.90002 20 5.40002 22 8.90002 22H16.9C20.4 22 21.9 20 21.9 17V7C21.9 4 20.4 2 16.9 2H8.90002C5.40002 2 3.90002 4 3.90002 7Z",
    stroke: "#344054",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4 4.5V6.5C10.4 7.6 9.50002 8.5 8.40002 8.5H6.40002",
    stroke: "#344054",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.42 15.4901C17.75 14.4601 17.36 13.1901 16.29 12.8401C15.72 12.6601 15.02 12.8101 14.63 13.3601C14.26 12.7901 13.53 12.6601 12.97 12.8401C11.89 13.1901 11.51 14.4601 11.83 15.4901C12.34 17.1201 14.13 17.9701 14.63 17.9701C15.12 17.9601 16.89 17.1301 17.42 15.4901Z",
    stroke: "#344054",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFav);
export default __webpack_public_path__ + "static/media/fav.958bfb9193ed71464fffa3cfa7f450ed.svg";
export { ForwardRef as ReactComponent };